/** @format */

import { ProductSku } from '@shared/data-access/interfaces';

export class SkuResolutionService {
	static getResolvedSku(
		availableSkusForSelection: ProductSku[],
		attributeNameValueObject: Record<string, string>
	): ProductSku | undefined {
		return availableSkusForSelection.find((sku) => {
			let invalidAttributes = [];
			if (sku.definingAttributes) {
				// checking each defining attribute against selections
				invalidAttributes = sku.definingAttributes.filter((attr) => {
					const selectedValue = attributeNameValueObject[attr.name];
					return (
						selectedValue && attr.value.toLowerCase() !== selectedValue.toLowerCase()
					);
				});
			}
			return invalidAttributes.length <= 0;
		});
	}
}
